import { Link, useRouteError, isRouteErrorResponse } from "react-router-dom";

export function RootError() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : "頁面發生錯誤";

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-3 bg-bg px-6 text-center">
      <p className="text-xs uppercase tracking-wider text-ink-400">Error</p>
      <h1 className="text-2xl text-ink-900">頁面無法載入</h1>
      <p className="max-w-md text-sm text-ink-500">{message}</p>
      <Link
        to="/"
        className="mt-2 inline-flex h-9 items-center rounded-md bg-primary-500 px-4 text-sm font-medium text-on-primary hover:bg-primary-600"
      >
        回首頁
      </Link>
    </div>
  );
}
